/*
 * jQuery Plugin: Scroller
 * Version 0.3
 *
 * Copyright (c) 2011 Shilov Vlad [Omgovich] (http://omgovich.ru)
 * No copyrights or licenses. Do what you want!
 *
 */

(function($) {
	$.fn.scroller = function(options) {
		// Settings
		var settings = $.extend({
			interval: 1000 / 60,
			step: 10,
			direction: 'horizontal',
			fixed: '.fixed',
			defaultZone: 0
		}, options);
		// Install scroller for each items
		this.each(function() {
			//** --- Variables --- **//
			var cursor = {
					position: 0
				},
				data = {
					size: 0,
					offset: 0
				},
				scroller = {
					enabled: true,
					offset: 0,
					ratio: 0,
					size: 0
				},
				animation,
				// Objects
				$scroller = $(this);

			if ($scroller.find('.slide-data').length === 0) {
				var $data = $scroller.wrapInner('<div class="slide-wrap"><div class="slide-data" /></div>').find('.slide-data'),
					$fixed = $scroller.find(settings.fixed);

				// Sizes and offsets
				if (settings.direction == 'vertical') {
					$scroller.addClass('vertical-slide-pane');
					data.size = $data.height();
					scroller.offset = $scroller.offset().top;
					scroller.size = $scroller.height();
				} else {
					$scroller.addClass('slide-pane');
					data.size = $data.width();
					scroller.offset = $scroller.offset().left;
					scroller.size = $scroller.width();
				}

				//** --- Implementation --- **//
				var checkMore = function() {
						if (data.offset === 0) {
							if ($scroller.hasClass('leftMore')) {
								$scroller.removeClass('leftMore').addClass('rightMore');
								// cancelAnimationFrame(animation);
							}
						} else if (data.offset === scroller.size - data.size) {
							if ($scroller.hasClass('rightMore')) {
								$scroller.removeClass('rightMore').addClass('leftMore');
								// cancelAnimationFrame(animation);
							}
						} else {
							$scroller.addClass('leftMore rightMore');
						}
					},
					checkDirMove = function() {
						if ((scroller.ratio < -settings.defaultZone) && (data.offset !== 0)) {
							$scroller.removeClass('mouseRight').addClass('mouseLeft');
						} else if ((scroller.ratio > settings.defaultZone) && (data.offset > scroller.size - data.size)) {
							$scroller.removeClass('mouseLeft').addClass('mouseRight');
						} else {
							$scroller.removeClass('mouseLeft mouseRight');
						}
					};

				checkMore();
				// event: Mousemove on scroller
				$scroller.mousemove(function(e) {
					if (settings.direction == 'vertical') {
						cursor.position = e.pageY - scroller.offset;
					} else {
						cursor.position = e.pageX - scroller.offset;
					}
					scroller.ratio = ((cursor.position + scroller.size) / (scroller.size) - 1.5) * 2;

					checkDirMove();
					checkMore();
				});
				// event: Mouseenter/Mouseover on scroller
				$scroller.hover(function() {
					cancelAnimationFrame(animation);
					if ((data.size > scroller.size) && (scroller.enabled)) {
						$data.stop();
						var animScroll = function() {
							if ((scroller.ratio < -settings.defaultZone) || (scroller.ratio > settings.defaultZone)) {
								var metaRatio = (Math.abs(scroller.ratio) - settings.defaultZone) / (1 - settings.defaultZone);

								if (scroller.ratio < 0) metaRatio = (-1) * metaRatio;
								data.offset = Math.min(0, data.offset - metaRatio * settings.step);
								data.offset = Math.max(data.offset, scroller.size - data.size);
								data.offset = Math.round(data.offset);
								if (settings.direction == 'vertical') {
									$data.css({
										top: data.offset
									});
									$fixed.css({
										top: -data.offset
									});
								} else {
									$data.css({
										// left: data.offset+'px'
										transform: 'translateX(' + data.offset + 'px)'
									});
									$fixed.css({
										left: -data.offset
									});
								}
								checkDirMove();
								checkMore();
							}
						};
						cancelAnimationFrame(animation);
						(function animationLoop() {
							animation = requestAnimationFrame(animationLoop);
							animScroll();
						})();
					}
				}, function() {
					cancelAnimationFrame(animation);
					$scroller.removeClass('mouseLeft mouseRight')
				});
				// event: Window resize - recalculate offset
				$(window).resize(function() {
					if (settings.direction == 'vertical') {
						$scroller.addClass('vertical-slide-pane');
						data.size = $data.height();
						scroller.offset = $scroller.offset().top;
						scroller.size = $scroller.height();
					} else {
						$scroller.addClass('slide-pane');
						data.size = $data.width();
						scroller.offset = $scroller.offset().left;
						scroller.size = $scroller.width();
					}
					checkDirMove();
					checkMore();
				});

				//** --- API --- **//

				var api = {
					disable: function() {
						$scroller.addClass('disabled');
						scroller.enabled = false;
						return true;
					},
					enable: function() {
						$scroller.removeClass('disabled');
						scroller.enabled = true;
						return true;
					},
					getStatus: function() {
						return scroller.enabled;
					},
					getOffset: function() {
						return data.offset;
					},
					getRatio: function() {
						return scroller.ratio;
					}
				}
				$scroller.data('scroller', api);
			}
		});
		return this;
	};
})(jQuery);